import axios from "axios";

const url = process.env.REACT_APP_BACKEND_HOST.concat("/spot/");
const urlScanner = process.env.REACT_APP_BACKEND_HOST.concat("/scanner/");

// Delete exam records by mode for a reqnum.
// deleteMode: "keys" | "students" | "both"
export async function deleteExamRecords(token, reqnum, deleteMode = "both") {
  return new Promise((resolve, reject) => {
    axios({
      method: "delete",
      url: urlScanner + "delete_exam_records/" + reqnum + "/",
      headers: {
        Authorization: `Token ${token}`,
      },
      params: {
        delete_mode: deleteMode,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

// 1) Upload the spreadsheet; server returns a canonical reorder_map object
export async function uploadReorderMap(token, reqnum, file) {
  const formData = new FormData();
  formData.append("file", file);
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: urlScanner + "upload_reorder_map/" + reqnum + "/",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    })
      .then((response) => {
        if (
          response.status === 200 &&
          response.data &&
          response.data.reorder_map
        ) {
          resolve(response.data.reorder_map);
        } else {
          reject(new Error("Bad response parsing reorder map"));
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

// (processExam already exists; we just pass reorder_map in the payload you build)

export async function updateScannerRequestParam(
  token,
  ccid,
  reqnum,
  mismatch,
  expected,
  got,
) {
  return new Promise((resolve, reject) => {
    axios({
      method: "put",
      url:
        urlScanner +
        "update_scanner_request_param/" +
        reqnum +
        "/" +
        ccid +
        "/",
      headers: {
        Authorization: `Token ${token}`,
      },
      data: { mismatch, expected, got },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export async function uploadExamFile(
  token,
  file,
  uploadMode = "upsert",
  operator = "",
) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_mode", uploadMode);
  if (operator) {
    formData.append("operator", operator);
  }
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: urlScanner + "upload_exam_file/",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    })
      .then(async (response) => {
        if (response.status === 200 || response.status === 202) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export async function updateAnswerKeyAttributes(token, reqnum, attributes) {
  console.log(attributes);
  return new Promise((resolve, reject) => {
    axios({
      method: "put",
      url: urlScanner + "update_answer_key_attributes/" + reqnum + "/",
      headers: {
        Authorization: `Token ${token}`,
      },
      data: attributes,
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export async function saveExamKeyAdvancedSettings(token, reqnum, keys) {
  return new Promise((resolve, reject) => {
    axios({
      method: "put",
      url: urlScanner + "save_exam_key_advanced_settings/" + reqnum + "/",
      headers: {
        Authorization: `Token ${token}`,
      },
      data: { keys },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export async function updateExamVersionCode(
  token,
  reqnum,
  oldVersion,
  newVersion,
) {
  return new Promise((resolve, reject) => {
    axios({
      method: "put",
      url: urlScanner + "update_exam_version_code/" + reqnum + "/",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        old_version: oldVersion,
        new_version: newVersion,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export async function deleteExamVersion(token, reqnum, version) {
  return new Promise((resolve, reject) => {
    axios({
      method: "delete",
      url: urlScanner + "delete_exam_version/" + reqnum + "/",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
      data: { version },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export async function mergeExamVersions(token, reqnum) {
  return new Promise((resolve, reject) => {
    axios({
      method: "put",
      url: urlScanner + "merge_exam_versions/" + reqnum + "/",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export async function updateExamReqClassID(token, reqnum, classid) {
  return new Promise((resolve, reject) => {
    axios({
      method: "put",
      url:
        urlScanner + "update_exam_req_classid/" + reqnum + "/" + classid + "/",
      headers: {
        Authorization: `Token ${token}`,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export async function updateStudentExamRecords(token, reqnum, students) {
  return new Promise((resolve, reject) => {
    axios({
      method: "put",
      url: urlScanner + "update_student_exam_records/" + reqnum + "/",
      headers: {
        Authorization: `Token ${token}`,
      },
      data: { students: students },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export async function resetModifiedAnswerKeyToOriginal(token, reqnum) {
  return new Promise((resolve, reject) => {
    axios({
      method: "put",
      url: urlScanner + "reset_modified_answer_key_to_original/" + reqnum + "/",
      headers: {
        Authorization: `Token ${token}`,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}
export async function updateModifiedAnswerKeys(token, reqnum, answer_keys) {
  console.log(answer_keys);
  return new Promise((resolve, reject) => {
    axios({
      method: "put",
      url: urlScanner + "update_modified_answer_key/" + reqnum + "/",
      headers: {
        Authorization: `Token ${token}`,
      },
      data: { answer_keys: answer_keys },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export async function processExam(token, reqnum, include_blanks, examData) {
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: urlScanner + "process_exam/" + reqnum + "/" + include_blanks + "/",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
      data: examData,
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export async function uploadExamFileStudents(token, file) {
  const formData = new FormData();
  formData.append("file", file);
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: urlScanner + "upload_exam_file_students/",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    })
      .then((response) => {
        if (response.status === 200 || response.status === 202) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
        //reject(error);
      });
  });
}

export async function sendFilesToInstructor({
  files,
  examProcessingState,
  token,
  subject,
  textBody,
  htmlBody,
  templatePreset,
  to = [],
  cc = [],
  bcc = [],
}) {
  const formData = new FormData();
  formData.append("subject", String(subject || ""));
  formData.append("text_body", String(textBody || ""));
  formData.append("html_body", String(htmlBody || ""));
  formData.append("template_preset", String(templatePreset || ""));

  (to || []).forEach((email) => {
    if (email) formData.append("to", email);
  });
  (cc || []).forEach((email) => {
    if (email) formData.append("cc", email);
  });
  (bcc || []).forEach((email) => {
    if (email) formData.append("bcc", email);
  });

  files.forEach((file) => {
    if (file?.blob && file?.name) {
      formData.append("attachments", file.blob, file.name);
    }
  });
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url:
        urlScanner +
        "send_files_to_instructor/" +
        examProcessingState.header.reqnum +
        "/",
      headers: {
        Authorization: `Token ${token}`,
      },
      data: formData,
    })
      .then((response) => {
        if (response.status === 200 || response.status === 202) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export async function getClasslistLDap(token, classids, term) {
  // console.log(classids);
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: url + "get_classlist_ldap/",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
      data: { classids: classids, term: term },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else if (response.status === 404) {
          reject(new Error("No data found"));
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export async function getCompleteGradingRequest(token, reqnum) {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url:
        urlScanner + "get_complete_grading_request/".concat(reqnum).concat("/"),
      headers: {
        Authorization: `Token ${token}`,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
        console.log("error");
        console.log(error);
      });
  });
}

export async function getExamKeys(token, reqnum) {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url: urlScanner + "fetch_exam_keys/".concat(reqnum).concat("/"),
      headers: {
        Authorization: `Token ${token}`,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        reject(error);
        console.log("error");
        console.log(error);
      });
  });
}

export async function getStudentResponses(token, reqnum) {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url: urlScanner + "fetch_student_responses/".concat(reqnum).concat("/"),
      headers: {
        Authorization: `Token ${token}`,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        reject(error);
        console.log("error");
        console.log(error);
      });
  });
}

export async function getScannerRequests(token, page, pageSize) {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url:
        urlScanner +
        "get_scanner_requests/"
          .concat(page)
          .concat("/")
          .concat(pageSize)
          .concat("/"),
      headers: {
        Authorization: `Token ${token}`,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          // Handle both old format (direct array) and new format (with pagination)
          if (response.data.results) {
            resolve(response.data);
          } else {
            // Backward compatibility - assume it's the old direct array format
            resolve({
              results: response.data,
              pagination: {
                page: page,
                page_size: pageSize,
                total_count: response.data.length,
                total_pages: 1,
                has_next: false,
                has_previous: false,
              },
            });
          }
        }
      })
      .catch((error) => {
        reject(error);
        console.log("error");
        console.log(error);
      });
  });
}

export async function getSpecificSidebarRequest(token, reqnum) {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url:
        urlScanner + "get_specific_sidebar_request/".concat(reqnum).concat("/"),
      headers: {
        Authorization: `Token ${token}`,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
        console.log("error");
        console.log(error);
      });
  });
}
